export const tourSteps = [
  {
    element: '[data-intro="data-table-tour"]',
    intro: "Displays all diet requests and optionally matching your filters if applied. You can scroll horizontally to see more columns.",
    position: 'top'
  },
  {
    element: '[data-intro="horizontal-dots-pager-above"]',
    intro: "Horizontal scrolling dots above the table. Click the dots to jump between column groups, or use the arrow button to scroll to the next set of columns. This shows when there are more columns than can fit on screen.",
    position: 'bottom'
  },
  {
    element: '[data-intro="horizontal-dots-pager"]',
    intro: "The same scrolling dots appear below the table for easy access. Click any dot to jump to that column group.",
    position: 'top'
  },
  {
    element: '[data-intro="pagination"]',
    intro: "Navigate through pages of results and adjust the number of items displayed per page.",
    position: 'top'
  },
  {
    element: '[data-intro="filter-toggle"]',
    intro: "Use filters to narrow down your search.",
    position: 'top'
  },
  {
    element: '[data-intro="pin-icon"]',
    intro: "Click this pin icon to pin columns to the left so they stay visible while scrolling horizontally. You can pin multiple columns and they'll stack from left to right. Click the pin again to unpin. Pin icons appear on hover for other columns.",
    position: 'bottom'
  },
  {
    element: '[data-intro="result-column"]',
    intro: "Click on any result value to view structured display of information about the diet request like horse details, pasture info, forages, messages received and details of any email reports that were sent.",
    position: 'top'
  }
];